<section class="breadcrumbs_common bg_img pos_relative">
  <div class="overlay-innerpage"></div>
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="breadcrumbs_content">
          <h2 class="text-white">M.Sc Computer Science</h2>
          <ul class="breadcrumb">
            <li>
              <a routerLink="/">Home</a>
            </li>/
            <li class="active">
              <a href="javascript:void(0);">M.Sc Computer Science</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="bba ptb--100  horizontal--tab">
  <div class="container">
    <div class="row">
      <div class="col">
        <ul class="nav nav-tabs" id="myTab" role="tablist">
          <li class="nav-item" role="presentation">
            <button class="nav-link active" id="eligibility-tab" data-bs-toggle="tab" data-bs-target="#eligibility"
              type="button" role="tab" aria-controls="eligibility" aria-selected="false">Eligibility Criteria</button>
          </li>
          <li class="nav-item" role="presentation">
            <button class="nav-link" id="process-tab" data-bs-toggle="tab" data-bs-target="#process" type="button"
              role="tab" aria-controls="process" aria-selected="false">Admission Process</button>
          </li>
        </ul>
        <div class="tab-content px-3 py-3" id="myTabContent">
          <div class="tab-pane fade show active" id="eligibility" role="tabpanel" aria-labelledby="eligibility-tab">
            <ul class="list-before">
              <li>Bachelor of Computer Science (BCS) with 50% marks (45% marks for Reserved Category as per the
                Maharashtra State Government Rules).</li>
              <li class="text-center"><strong>OR</strong></li>
              <li>TB.Sc. (Computer Science) with 50% marks (45% marks for Reserved Category as per the Maharashtra State
                Government Rules).</li>
              <li class="text-center"><strong>OR</strong></li>
              <li>A Bachelor of Engineering in Computer Science / Information Technology / Electronic Telecommunication
                with 50% marks (45% marks for Reserved Category as per the Maharashtra State Government Rules).</li>
            </ul>
          </div>
          <div class="tab-pane fade" id="process" role="tabpanel" aria-labelledby="process-tab">
            <p>An eligible student has to apply through the college application form for admission. Admissions will be
              offered to the students on their merit basis.</p>

          </div>
        </div>
      </div>
    </div>
  </div>
</section>
